module.exports = __webpack_public_path__ + "static/media/all-events-white.c88a4ebe.svg";